import React, { useCallback, useEffect, useState } from "react";
import styles from "../../pages/Event_page/Event.module.scss";
import Layout from "../../layouts/Layout/Layout";
import { CardImage } from "../../ui";
import EventCard from '../../pages/Event_page/components/EventCard/EventCard';
import { Button } from "../../elements";
import THEME from "../../../state/theme";
import { useCustomState } from "../../../state/state";
import { TopCard } from "../../pages/Event_page/components";

export default ({ data = [], sidebar = "left", layout = "grid", title = "title" }) => {
  // const [state, actions] = useCustomState();
  const state = useCustomState()[0];
  // const { category, author, posting_date, query } = useParams();
  // const { url } = useRouteMatch();

  const [pastcurrentPage, pastsetCurrentPage] = useState(1);
  const [topcurrentPage, topsetCurrentPage] = useState(1);
  const pastpostsPerPage = useState(6)[0];
  const toppostPerPage = useState(1)[0];
  const [toppostsArray, settopPostsArray] = useState([]);
  const [pastpostsArray, setpastPostsArray] = useState([]);
  const [pageTitle, setPageTitle] = useState(title);

  let pastposts = [...state.data.events];
  let topposts = [];

  const filterTopPosts = useCallback(() => {
    topposts[0] = pastposts.shift()
    // if (category) {
    //   posts = state.data.posts.filter(
    //     (post) => category === post.category_id.toString()
    //   );
    //   setPageTitle(
    //     "Category: " +
    //       state.data.categories.filter((cat) => cat.id === category)[0].title
    //   );
    // } else if (author) {
    //   posts = state.data.posts.filter(
    //     (post) => author === post.user_id.toString()
    //   );
    //   setPageTitle(
    //     "Author: " +
    //       state.data.users.filter((user) => user.id.toString() === author)[0]
    //         .name
    //   );
    // } else if (posting_date) {
    //   posts = state.data.posts.filter(
    //     (post) => posting_date === post.posting_date
    //   );
    //   setPageTitle("Date: " + posting_date);
    // } else if (query) {
    //   posts = state.data.posts.filter((post) => post.title.includes(query));
    //   setPageTitle("Search for: " + query);
    // } else {
    //   setPageTitle(title);
    // }
    return topposts;
  }, [
    // author,
    // category,
    // posting_date,
    // query,
    // state.data.categories,
    // state.data.posts,
    // state.data.users,
    title,
  ]);

  const filterpastPosts = useCallback(() => {

    return pastposts;
  }, [title]);

  useEffect(() => {
    settopPostsArray(
      filterTopPosts().map((post, index) => {
        return (
          <TopCard
            key={index}
            layout={"list"}
            post={post}
          // author={
          //   "Lorem Ipsum"
          // }
          />
        );
      })
    );
    topsetCurrentPage(1);

    setpastPostsArray(
      filterpastPosts().map((post, index) => {
        return (
          <EventCard
            key={index}
            layout={layout}
            post={post}
          // author={
          //   "Lorem Ipsum"
          // }
          />
        );
      })
    );
    pastsetCurrentPage(1);
  }, [
    layout,
    // category,
    // author,
    // query,
    // posting_date,
    // url,
    // state.data.users,
    // state.data.categories,
    filterTopPosts,
    filterpastPosts,
  ]);


  const teamList = data.map((item, index) => (
    <article key={index}>
      <CardImage image={item.img} label="from 50$">
        <div className={styles.card}>
          <span>{item.job}</span>
          <h3>{item.name}</h3>
          <Button
            round
            after="&#xf107;"
            type="solid-color-tb"
            hoverType="solid-gray-tb"
            to={"/team/" + item.id}
          />
        </div>
      </CardImage>
    </article>
  ));

  return (
    <Layout
      style={{
        background: "url(" + state.data.header_bgs.team_w + ") center/cover",
      }}
      mode="dark"
      padding
      blur
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div className="layout-header">
          <span className="subtitle" style={{ color: THEME.color }}>
            Recent Events
          </span>
          <h2 style={{ color: "#fff" }}>
            We at Ruminate organize various event to keep spark active.
          </h2>
          {/* <p style={{ color: "#fff" }}>
          Energistically predominate high-payoff alignments whereas maintainable
          materials timely deliverables. Synergistically leverage other's
          holistic mindshare via high-payoff expertise.
        </p> */}
        </div>
        <section

          className={[
            styles.wrapper,
            sidebar === "left"
              ? styles.with_sidebar + " " + styles.left
              : sidebar === "right"
                ? styles.with_sidebar + " " + styles.right
                : null,
          ].join(" ")}
        >

          {/* <aside className={styles.sidebar}>
        <BlogSearch />
        <BlogCategories data={state.data.categories} />
        <BlogFeatured data={state.data.posts} />
      </aside> */}

          <article>
            <div
              className={
                layout === "list"
                // ? styles.grid
                // : layout === "list"
                // ? styles.list
                // : null
              }
            >
              {toppostsArray.slice(
                (topcurrentPage - 1) * toppostPerPage,
                topcurrentPage * toppostPerPage
              )}
            </div>

          </article>
        </section>
        <section
          className={[
            styles.wrapper,
            sidebar === "left"
              ? styles.with_sidebar + " " + styles.left
              : sidebar === "right"
                ? styles.with_sidebar + " " + styles.right
                : null,
          ].join(" ")}
        >
          {/* <aside className={styles.sidebar}>
          <BlogSearch />
          <BlogCategories data={state.data.categories} />
          <BlogFeatured data={state.data.posts} />
        </aside> */}

          <article>
            <div
              className={
                layout === "grid"
                  ? styles.grid
                  : layout === "list"
                    ? styles.list
                    : null
              }
            >
              {pastpostsArray.slice(0, 2)}
            </div>


          </article>
        </section>
      </div>
      {/* {teamList} */}
      {/* <div className={["layout-footer", styles.footer].join(" ")}>
        <span>
          <b style={{ color: THEME.color }}>Let's start do business. </b>
          <br />
          Make arrangement and get discount.
        </span>
        <Button
          hoverType="solid-white-tb"
          click={() =>
            actions.toogleRequest("Make arrangement and get discount")
          }
        >
          Make request
        </Button>
      </div> */}
      <div style={{ marginTop: '3rem', maxWidth: '30%', marginLeft: 'auto', marginRight: "auto" }} className={styles.btn}>
        <Button to="/events" hoverType="solid-gray-tb" >
          More
        </Button>
      </div>
    </Layout >
  );
};
